import { Box } from "@mui/system"
import { Tab, Tabs } from "@mui/material"
import { SyntheticEvent, useState } from "react"
import { MerchantNewsTab } from "./MerchantNewsTab"
import { MerchantArchiveNewsTab } from "./MerchantArchiveTab"
import { useNavigate } from "react-router-dom"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { TabPanel } from "../../../../../shared/components/tabs/tabPanel"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { MERCHANT_ADMIN_ROUTE, MERCHANT_NEWS_CREATE_NEWS_ITEM_ROUTE } from "../../../../../constants/routes"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"

export function MerchantNews() {
    const navigate = useNavigate()

    const [value, setValue] = useState(0)
    const { l10n } = useAppLocalization()

    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    return (
        <>
            <LocalizedStrict id="merchant-news-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_NEWS}
                    title="News"
                    rightElement={
                        <LocalizedStrict id="news-create-new-button">
                            <StandardButton onClick={() => navigate(MERCHANT_NEWS_CREATE_NEWS_ITEM_ROUTE)}>
                                Create new
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-communication-header">
                            <Breadcrumb>Communication</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-merchant-news">
                            <Breadcrumb>News</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={value} onChange={handleChange}>
                    <Tab value={0} label={l10n.getString("news-current-news")} wrapped sx={{ textTransform: "none" }} />
                    <Tab value={1} label={l10n.getString("news-archive-news")} wrapped sx={{ textTransform: "none" }} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <MerchantNewsTab />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <MerchantArchiveNewsTab />
            </TabPanel>
        </>
    )
}
